import { render } from "./UnauthorizedColors.vue?vue&type=template&id=10244746&scoped=true"
import script from "./UnauthorizedColors.vue?vue&type=script&lang=js"
export * from "./UnauthorizedColors.vue?vue&type=script&lang=js"

import "./UnauthorizedColors.vue?vue&type=style&index=0&id=10244746&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10244746"]])

export default __exports__